/*
* Column: bind clone events
*
* @since 2.0
*/
var clone = function (column) {
    column.$el.find('.clone-button').click(function (e) {
        e.preventDefault();
        if (column.isOriginal()) {
            return;
        }
        AdminColumns.Form.cloneColumn(column.$el);
    });
};
export default clone;
